import { combineReducers } from 'redux';
import { cloneDeep } from 'lodash';

import {
	FETCH_DATA_SUCCESS,
	TOGGLE_YEARS,
	TOGGLE_YEAR,
	CLEAR_FILTERS,
	SET_FILTERED_YEARS,
	LOGOUT_USER,
	CLOSE_DROPDOWNS,
} from '../types';

const toggleYear = (state, payload) => {
	const { id, selected } = payload;

	return {
		...state,
		[id]: { ...state[id], selected  }
	}
}

const deselectAllYears = state => {
	const newYears = cloneDeep(state);

	Object.entries(newYears).forEach(([key, value]) => {
		value.selected = false;
	});
	return newYears;
}

const byId = (state = {}, action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			return {
				...state,
				...action.payload.files.entities.years,
			}

		case TOGGLE_YEAR:
			return toggleYear(state, action.payload);

		case CLEAR_FILTERS:
			return deselectAllYears(state);

		case LOGOUT_USER:
			return {}

		default:
			return state;
	}
}

const allIds = (state = [], action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			const keys = Object.keys(action.payload.files.entities.years);
			return keys.map(Number);

		case LOGOUT_USER:
			return []

		default:
			return state;
	}
}

const filteredIds = (state = [], action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			const keys = Object.keys(action.payload.files.entities.years);
			return keys.map(Number);

		case SET_FILTERED_YEARS:
			return action.payload

		
		case CLEAR_FILTERS:
			return action.payload.years

		case LOGOUT_USER:
			return []

		default:
			return state;
	}
}

const metaInitialState = {
	active: false,
}

const meta = (state = metaInitialState, action) => {
	switch (action.type) {
		case TOGGLE_YEARS:
			return {
				...state,
				active: !state.active,
			}
		
		case CLEAR_FILTERS:
			return {
				...state,
				active: false,
			}

		case LOGOUT_USER:
			return metaInitialState;

		case CLOSE_DROPDOWNS:
			return metaInitialState;
			
		default:
			return state;
	}
}

const years = combineReducers({
	byId,
	allIds,
	filteredIds,
	meta,
});
export default years;

export const getIsActive = state => state.meta.active;
export const getIds = state => state.allIds;
export const getFilteredIds = state => state.filteredIds;
export const getYears = state => {
	const ids = getFilteredIds(state);
	return ids.map(id => state.byId[id]);
}
export const getSelectedYears = state => {
	const ids = getIds(state);
	return ids.filter(id => state.byId[id].selected);
}


// WEBPACK FOOTER //
// ./src/store/years/reducer.js